var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 4",
    opacity: 0.253397,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.363836 55.618C0.363836 55.618 0.935032 52.4629 3.1812 59.8822C5.42737 67.3015 30.8263 83.5398 39.3284 70.3889C47.8304 57.2381 59.8505 71.995 68.1538 68.0483C76.457 64.1015 77.7722 58.8926 71.5832 46.3416C65.3942 33.7906 80.6183 18.4967 65.4426 8.66423C50.2669 -1.16822 62.0153 1.24728 62.0153 1.24728L61.938 41.39L41.6239 59.8069L0.363836 55.618Z",
    fill: "url(#paint0_linear_1_375)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_375",
    x1: 3.42636,
    y1: 17.5373,
    x2: 122.437,
    y2: 61.5395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.f3ae5eb898b7dcc5d593f9d6e185471c.svg";
export { ForwardRef as ReactComponent };